import { render, staticRenderFns } from "./newTable.vue?vue&type=template&id=12ab6cac&scoped=true"
import script from "./newTable.vue?vue&type=script&lang=js"
export * from "./newTable.vue?vue&type=script&lang=js"
import style0 from "./newTable.vue?vue&type=style&index=0&id=12ab6cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab6cac",
  null
  
)

export default component.exports